import { useMutation } from "react-query";
import { postSearchPartner } from "../api";

export const usePostSearchPartner = () => {
  return useMutation(postSearchPartner);
};
